export enum AdType {
  Gold,
  Normal,
}
